// extracted by mini-css-extract-plugin
export var container = "_hg-0";
export var segment = "_hg-2";
export var segmentActive = "_hg-3";
export var track = "_hg-1";